/**
 * Notifications bell (AB#84509). It covers a single notice for now — an invitation
 * to an additional organization. The notifications epic (#84880) grows from here.
 */
const notifications = {
  title: "Notifications",
  empty: "No notifications yet",
  invite: {
    title: "Invitation to {{organization}}",
    description:
      "Accepting makes this organization available to you — your current access stays as it is.",
    accept: "Accept invitation",
    acceptFailed: "Could not accept the invitation",
    syncFailed: "Organization added",
    syncFailedDescription: "Reload the page to see your full access in it.",
  },
} as const;

export default notifications;
